import React from 'react';

function SortSelector({ options, sortConfig, onSortChange }) {
  return (
    <div className="sort-selector no-print" style={{display: 'flex', alignItems: 'center', gap: '0.75rem', padding: '0.4rem 0.75rem', fontSize: '0.85rem'}}>
      <label style={{fontWeight: 500, color: 'var(--text-secondary)', whiteSpace: 'nowrap'}}>Sort by:</label>
      <select 
        style={{border: 'none', background: 'transparent', fontWeight: 600, color: 'var(--primary-color)', cursor: 'pointer', padding: '0.2rem'}}
        value={`${sortConfig.key}-${sortConfig.direction}`} 
        onChange={(e) => {
          const [key, direction] = e.target.value.split('-');
          onSortChange({ key, direction });
        }}
      >
        {options.map(opt => (
          <React.Fragment key={opt.key}>
            <option value={`${opt.key}-asc`}>{opt.label} (A-Z)</option>
            <option value={`${opt.key}-desc`}>{opt.label} (Z-A)</option>
          </React.Fragment>
        ))}
      </select>
    </div>
  );
}

export default SortSelector;
